var classes = {"slashIcon":"oGjBK"};

export { classes as default };
